import { createTheme } from '@mui/material/styles';

import { darkThemeValues } from './darkThemeValues';
import { defaultThemeValues } from './defaultThemeValues';
import { KitTheme } from './theme.types';

export const defaultTheme = createTheme(defaultThemeValues) as KitTheme;
export const darkTheme = createTheme(darkThemeValues) as KitTheme;
